import { Wrapper } from "./Wrapper";



export class ColorSpace extends Wrapper {
  constructor(libmupdf: any, ctx: number, pointer: number) {
    super(libmupdf, ctx, pointer, libmupdf._wasm_drop_colorspace);
  }
}
